<template>
  <div class="list-item">
    <div>
      <img :src="require(`@/assets/${img}.png`)" alt="" class="list-image" />
    </div>
    <div>
      <div class="list-title">
        <span class="">{{ title }}</span>
      </div>
      <div class="list-sub-title">
        <span>{{ subTitle }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["img", "title", "subTitle"],
};
</script>

<style scoped>
.list-item {
  display: flex;
  margin-bottom: 20px;
}

.list-image {
  width: 85px;
  height: 85px;
  background: #c4c4c4;
  border-radius: 50%;
}

.list-title {
  font-family: Noto Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 26px;
  color: #1d1d1d;
  text-align: left;
  padding: 0 20px;
}

.list-sub-title {
  font-family: Noto Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  color: #1d1d1d;
  text-align: left;
  padding: 0 20px;
}
</style>
